import React, { useEffect } from "react";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import { Outlet, useLocation } from "react-router-dom";
import AuthWrapper from "../HOC/AuthWrapper";
import { Toaster } from "sonner";
import ModalPopup from "../components/ModelPopup";
import { useDispatch, useSelector } from "react-redux";
import RegisterModel from "../pages/auth/RegisterModel";
import InquirySendModel from "../components/CartPanel/InquirySendModel";
import {
  openInquiryModel,
  openRegisterModel,
} from "../store/slices/commonSlice";

const Layout = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { inquiryModelState, registerModelState } = useSelector(
    (state) => state.common
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // Google Analytics pageview tracking
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-N1ZZREYST9", {
        page_path: pathname,
      });
    }
  }, [pathname]);
  return (
    <AuthWrapper>
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <AppHeader />
      </div>
      <div className="main-content">
        <Outlet />
      </div>
      <AppFooter />
      <Toaster
        visibleToasts={1}
        position="top-center"
        toastOptions={{
          style: {
            border: "1px solid #97602d",
          },
        }}
      />
      <ModalPopup
        isOpen={inquiryModelState}
        onClose={() => dispatch(openInquiryModel(false))}
      >
        <InquirySendModel />
      </ModalPopup>
      <ModalPopup
        isOpen={registerModelState}
        onClose={() => dispatch(openRegisterModel(false))}
      >
        <RegisterModel />
      </ModalPopup>
    </AuthWrapper>
  );
};

export default Layout;
